

















import { defineComponent } from '@vue/composition-api';
import TtamAvatarUploader from '@/components/common/avatar-uploader/index.vue';
const name = 'ttam-identity-custom-create';

export default defineComponent({
  name,
  components: { TtamAvatarUploader },
  props: {
    headers: {
      type: Object,
      default: () => ({}),
    },
    action: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onRemove = () => {
      emit('avatar-remove');
    };
    const onSuccess = data => {
      emit('avatar-success', data);
    };
    const onError = err => {
      emit('avatar-error', err);
    };

    return {
      name,
      onError,
      onRemove,
      onSuccess,
    };
  },
});
